import React, { useMemo } from 'react';

const PASSWORD_REQUIREMENTS = [
  {
    label: 'At least 8 characters',
    test: (pw: string) => pw.length >= 8,
    key: 'minLength',
  },
  {
    label: 'At least one uppercase letter',
    test: (pw: string) => /[A-Z]/.test(pw),
    key: 'uppercase',
  },
  {
    label: 'At least one lowercase letter',
    test: (pw: string) => /[a-z]/.test(pw),
    key: 'lowercase',
  },
  {
    label: 'At least one number',
    test: (pw: string) => /[0-9]/.test(pw),
    key: 'number',
  },
  {
    label: 'At least one special character',
    test: (pw: string) => /[^A-Za-z0-9]/.test(pw),
    key: 'special',
  },
];

interface PasswordRequirementsProps {
  password: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password }) => {
  const checks = useMemo(
    () =>
      PASSWORD_REQUIREMENTS.map(req => ({
        ...req,
        met: req.test(password),
      })),
    [password]
  );

  return (
    <ul className="mb-1 mt-2 space-y-1 text-xs">
      {checks.map(req => (
        <li
          key={req.key}
          className={
            req.met
              ? 'flex items-center text-gray-500 dark:text-gray-400'
              : 'flex items-center text-gray-500 dark:text-gray-400'
          }
        >
          <span className="mr-1">{req.met ? '✔️' : '❌'}</span> {req.label}
        </li>
      ))}
    </ul>
  );
};

export default PasswordRequirements;
